import Vue from 'vue';

/** 用以区分不同的端，如：社区、物业、政务 */
const PLAT_FORM = 'community';

Vue.prototype.PLAT_FORM = PLAT_FORM;

export { PLAT_FORM };
